import { initAdjustWeb } from '@/init/adjustWeb'
import { initMixpanel } from '@/init/mixpanel'
import { sentryInit } from '@/init/sentry-init'
import { Mixpanel } from '@/analytics/mixpanel'
import { initAB } from '@/services/ab'

const tableOfContentsJS = require('@/assets.v2/js/tableOfContents.js')
const { tableOfContentsHighlighting, toggleTableOfContents } = tableOfContentsJS

const headerJS = require('@/assets.v2/js/header.js')
const { header } = headerJS

export function initPageSummaryV2(): void {
  initMixpanel()
  sentryInit()
  initAdjustWeb()

  document.addEventListener('DOMContentLoaded', async function () {
    header()
    tableOfContentsHighlighting()
    toggleTableOfContents()
    await initAB()
    Mixpanel.pageView()
  })
}
